var exports = {
  "kL": "xe564cbfb--866762--container",
  "Pf": "xe564cbfb--866762--label",
  "PZ": "xe564cbfb--866762--label--clickable",
};

module.exports = exports;
